import { Box, Divider, Grid, Typography, useTheme } from '@mui/material';
/* import facebookLogo from "../../assets/socialmedia/facebook.png";
import instagramLogo from "../../assets/socialmedia/instagram.png";
import TwitterLogo from "../../assets/socialmedia/twitter.png"; */

const Footer = () => {
  const theme = useTheme();
  const logo = '/assets/images/Americas-Logo.png';

  /*   const FacebookUrl = "https://es-la.facebook.com/";
  const InstagramUrl = "https://www.instagram.com/";
  const TwitterUrl = "https://twitter.com/?lang=es"; */

  return (
    <Box
      height={'auto'}
      width={'100%'}
      sx={{
        bgcolor: theme.palette.gray.light,
        marginTop: 'auto',
        display: 'flex',
        p: 2,
      }}
    >
      <Grid container spacing={2}>
        <Grid item md={5}>
          <img
            src={logo}
            height={'60px'}
            style={{ maxWidth: '100%', cursor: 'pointer' }}
            alt="Company logo"
          />
          <Typography
            sx={{
              fontWeight: '700',
              color: theme.palette.gray.dark,
              fontSize: '14px',
            }}
          >
            Americas Communications LLC
          </Typography>

          <Typography
            sx={{ color: theme.palette.gray.dark, fontSize: '12px', textAlign: 'justify' }}
          >
            This platform contains project-related information intended for authorized clients of
            Americas Communications LLC. The content is provided for reference only and may include
            confidential or proprietary details. Information shown here does not replace official
            vendor documentation.
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Divider orientation="vertical" />
            <FooterText
              Title={'Contact information'}
              subTitle={'6100 W, Gila Springs Place, Suite 7 Chandler, AZ, 85226-3539'}
              body1={'Phone:  (602)-304-1760'}
              body2={'Email:  info@americasrf.com'}
            />
            {/*  <FooterText
              Title={'Email'}
              body1={'PO Box 2928'}
              body2={'Morgan Boulevart'}
              body3={'Window Rock, Arizona 86515'}
            />
            <FooterText
              Title={'Phone number'}
              subTitle={'Radio shop No. 7447'}
              body1={'Phone: 928-871-7743'}
              body2={'Fax:  928-871-7742'}
            /> */}
          </Box>
        </Grid>

        {/* <Grid item md={1}>
          <Box
            height={"100%"}
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems={"flex-end"}
          >
            <a
              href={FacebookUrl}
              alt="Client's Web page"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={facebookLogo}
                height={"35px"}
                style={{ maxWidth: "100%", cursor: "pointer" }}
                alt="Facebook"
              />
            </a>

            <a
              href={InstagramUrl}
              alt="Client's Web page"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={instagramLogo}
                height={"35px"}
                style={{ maxWidth: "100%", cursor: "pointer" }}
                alt="Facebook"
              />
            </a>
            <a
              href={TwitterUrl}
              alt="Client's Web page"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={TwitterLogo}
                height={"35px"}
                style={{ maxWidth: "100%", cursor: "pointer" }}
                alt="Facebook"
              />
            </a>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
};

const FooterText = ({ Title, subTitle, body1, body2, body3 }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        color: theme.palette.gray.dark,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontWeight: '700', fontSize: '17px' }}>{Title}</Typography>
      {subTitle && <Typography sx={{ fontWeight: '600', fontSize: '14px' }}>{subTitle}</Typography>}
      <Typography sx={{ fontSize: '14px' }}>{body1} </Typography>
      <Typography sx={{ fontSize: '14px' }}>{body2} </Typography>
      {body3 && <Typography sx={{ fontSize: '14px' }}>{body3} </Typography>}
    </Box>
  );
};
export default Footer;
